import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Learner/LogInPage/Button';
import ErrorMessage from '../../../components/Learner/LogInPage/ErrorMessage';
import './styles.css';

const LogInPage = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  // Check if user already logged in - trust stored token and/or userData
  // No decoding/verification - backend will validate token on API calls
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userDataStr = localStorage.getItem('userData');
    
    if (token || userDataStr) {
      console.log('✅ Token and/or userData found, redirecting to dashboard (backend will validate)...');
      navigate('/learner/dashboard');
    }
  }, [navigate]);

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="learner-login-container">
        <img 
          src="/ZenVokus-New/Label Persegi Panjang Lautan (1).png" 
          alt="ZenVokus Logo" 
          className="learner-login-logo"
        />
        
        {/* Login Card */}
        <div className="learner-login-card">
          <div className="learner-login-header">
            <h1 className="learner-login-title">Learner log in</h1>
            <p className="learner-login-subtitle">Welcome back! Please login to your account.</p>
          </div>

          <div className="learner-login-form">
            <Button onError={setError} />
            
            <ErrorMessage message={error} />
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LogInPage;
